import { TypographyV3 } from '@jouzen/ecom-components';
import type { JSX, ReactElement } from 'react';

interface TOCEntryProps {
  readonly label: JSX.Element | string;
  readonly summary: JSX.Element | string;
  readonly icon: ReactElement | null;
}

const TOCEntry = ({ label, summary, icon }: TOCEntryProps): JSX.Element => {
  return (
    <div className="flex gap-2 md:flex-col">
      <div className="grow-0">{icon}</div>
      <div>
        <TypographyV3 color="inherit" variant="h6" weight="normal" Element="h2">
          {label}
        </TypographyV3>
        <TypographyV3 color="inherit" className="mt-2">
          {summary}
        </TypographyV3>
      </div>
    </div>
  );
};

export default TOCEntry;
